import { render, staticRenderFns } from "./WallDonationBlockSettings.vue?vue&type=template&id=1f617579"
import script from "./WallDonationBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallDonationBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports